import script from "./read-only-input.vue?vue&type=script&lang=ts&setup=true"
export * from "./read-only-input.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__